// extracted by mini-css-extract-plugin
export default {"root":"ReferencesList_root__ZO2Z8","root_nothing":"ReferencesList_root_nothing__Ap-u-","window":"ReferencesList_window__ghzI3","noting":"ReferencesList_noting__01QTx"};